import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/all';
import * as announcementAction from '../actions/announcement';
import * as coreActions from '../actions/core';
import { Log } from 'ng2-logger';
import { LoginService } from '../../api/login-service';
import { AnnouncementPageService } from '../../api/announcement-service';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';

const T = Translator.create();
const _logger = Log.create('Login Sagas');
// #region login announcement data
function* setLoginAnnouncementData(params: any): any {
    const _loginService = new LoginService();
    let isError = false;
    let errorList: any;

    try {
        const requestReturn = yield _loginService.LoginAnnoucementData(params.organizationId).then((response: Response) => {
            return response;
        }).then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }
            
            return response.json();
        }).then((responseData) => {
            if (isError) {
                errorList = responseData;
            } else {
                return responseData;
            }
        });

        if (isError) {
            yield put(announcementAction.SetLoginAnnouncementError(true));
            if(errorList?.length > 0) {
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) 
            }
        }

        if (!isError) {
            yield put(announcementAction.SetLoginAnnouncement(requestReturn));
            yield put(announcementAction.SetLoginAnnouncementError(false));
        }
    } catch (error: any) {
        yield put(announcementAction.SetLoginAnnouncementError(true));
    }
}

function* setLoginAnnouncementDataById(params: any): any {
    const _announcementService = new AnnouncementPageService();
    let isError = false;
    let errorList: any;
    try {
        yield put(announcementAction.SetLoginAnnouncementByIdAction(null, false));
        const requestReturn = yield _announcementService.RequestGetSelectedAnnouncementAsync(params.announcementId).then((response: Response) => {
            return response;
        }).then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }

            return response.json();
        }).then((responseData) => {
            if (isError) {
                errorList = responseData;
            } else {
                return responseData;
            }
        });

        if (isError) {
            (errorList) ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_course_page_lessonPage_announcements_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(announcementAction.SetLoginAnnouncementByIdAction(requestReturn, true, params.spinnerId, 'set', params.announcementIndex));
        }
    } catch (error: any) {
        // catch error!
        yield put(coreActions.newNotification(T.t('r_course_page_lessonPage_announcements_error_message'), '', '', 'topRight', 'error'));
    }
}

// #endregion


// #region login announcement data
export function* watchLoginAnnouncementData() {
    yield takeEvery(constants.announcementAction.LOGIN_ANNOUNCEMENT_GET, setLoginAnnouncementData);
}
// #endregion

export function* watchLoginAnnouncementDataById() {
    yield takeEvery(constants.announcementAction.GET_SELECTED_LOGIN_ANNOUNCEMENT, setLoginAnnouncementDataById);
}


export default function* announcementSagas() {
    yield all([
        watchLoginAnnouncementData(),
        watchLoginAnnouncementDataById()
    ]);
}
